import { render, staticRenderFns } from "./AuthorizationSelect.vue?vue&type=template&id=5e5e029e&scoped=true"
import script from "./AuthorizationSelect.vue?vue&type=script&lang=js"
export * from "./AuthorizationSelect.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationSelect.vue?vue&type=style&index=0&id=5e5e029e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e029e",
  null
  
)

export default component.exports